import { Paper, Grid, Box } from "@mui/material";
import "../mobileViewList.css";
import { useRef, useState } from "react";
import useAdaptiveEllipsis from "../../../../Hooks/Adaptive/useAdaptiveEllipsis";

export default function RichiesteAccessoRowStructures({ row, BoxButton }) {
    const [paragraphWidth, setParagraphWidth] = useState(null);
    const gridItemRef = useRef(null);
    useAdaptiveEllipsis(gridItemRef, setParagraphWidth, -13);

    const initials =
        (row.firstName?.charAt(0) ?? "").toUpperCase() +
        (row.lastName?.charAt(0) ?? "").toUpperCase();

    return (
        <Paper className="row-mobileView box-shadow-light">
            <Grid container>
                {/* AVATAR */}
                <Grid item xs={2} sm={1} style={{ maxWidth: "55px" }}>
                    <div className="booking-card-left-section bk-icon-mob flex-center-center">
                        <div
                            style={{
                                background: "#3e6bb4",
                                width: "27px",
                                height: "27px",
                                borderRadius: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "white",
                                fontSize: "11px",
                            }}
                        >
                            {initials || "?"}
                        </div>
                    </div>
                </Grid>

                {/* CONTENUTO */}
                <Grid item xs={10} sx={{ paddingTop: "5px" }}>
                    <Grid
                        item
                        xs={12}
                        className="mobileRow-center-text"
                        sx={{ maxWidth: "100%" }}
                        ref={gridItemRef}
                    >
                        <p
                            className="font-segoeui firstRow-mobileView textOverflowEllipsis"
                            style={{ width: paragraphWidth }}
                        >
                            {row.firstName} {row.lastName}
                        </p>
                        <p
                            className="font-segoeui secondRow-mobileView textOverflowEllipsis"
                            style={{ width: paragraphWidth }}
                        >
                            {row.email}
                        </p>
                        <p className="font-segoeui secondRow-mobileView">
                            {row.dateRequest}
                        </p>
                    </Grid>

                    {BoxButton && (
                        <Grid item xs={12}>
                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: "6px", mt: 0.5, mb: 0.5 }}>
                                <BoxButton row={row} />
                            </Box>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Paper>
    );
}